import { createStore, createLogger } from 'vuex';
// import createPersistedState from 'vuex-persistedstate';

import { store as zelos, BestellungStore, State as BestellungState } from '@/modules/ewwms/store/modules/Bestellung';
import { store as umfuhr, UmfuhrStore, State as UmfuhrState } from '@/modules/ewwms/store/modules/Umfuhr';
import { store as bestand, BestandStore, State as BestandState } from '@/modules/ewwms/store/modules/Bestand';
import { store as artikel, ArtikelStore, State as ArtikelState } from '@/modules/ewwms/store/modules/Artikel';

export type RootState = {
  bestellung: BestellungState;
  umfuhr: UmfuhrState;
  bestand: BestandState;
  artikel: ArtikelState;
};

export type Store = BestellungStore<Pick<RootState, 'bestellung'>> &
  UmfuhrStore<Pick<RootState, 'umfuhr'>> &
  BestandStore<Pick<RootState, 'bestand'>> &
  ArtikelStore<Pick<RootState, 'artikel'>>;

const debug = process.env.NODE_ENV !== 'production';
const plugins = debug ? [createLogger({})] : [];

// plugins.push(createPersistedState({ storage: window.sessionStorage }));

export const store = createStore({
  plugins,
  modules: {
    zelos: zelos,
    umfuhr: umfuhr,
    bestand: bestand,
    artikel: artikel,
  },
});

export function useStore(): Store {
  return store as Store;
}
